import { transparentize } from 'polished'
import styled from 'styled-components'

import { ButtonAsync, muiRipple } from '@subaio/components'

import { helpers } from 'styles'

export const Button = styled(ButtonAsync)`
	color: ${({ theme }) => theme.color.primary};
	background-color: ${({ theme }) => transparentize(0.9, theme.color.primary)};
	font-family: ${helpers.font.family.header};

	min-width: initial;
	height: 34px;
	width: 34px;
	padding: 0;
	margin: 2px 0 2px 2px;
	border-radius: 12px;
	transition: color 0.2s, background-color 0.2s;
	isolation: isolate;

	&:is(:focus-visible, :hover) {
		background-color: ${({ theme }) => transparentize(0.8, theme.color.primary)};
	}

	&:focus-visible {
		outline: 2px solid ${helpers.color.link};
		outline-offset: -2px;
	}

	&:disabled {
		color: ${helpers.color.disabled};
		background-color: transparent;
	}

	${muiRipple()}
`
